import React from 'react';
import { G, Path } from 'react-native-svg';

import { IconDef, IconSpecificStyles } from './types';

export const ArrowLeft: IconDef = {
  svg: (
    <G>
      <Path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M15 18L9 12L15 6"
      />
    </G>
  ),
  svgStyles(color): IconSpecificStyles {
    return {
      stroke: color,
      strokeWidth: 2,
    };
  },
};
